export interface Comment {
	id: string,
	resourceId: string,
	createdBy: User
	content: string,
	createdAt: string,
	editedAt: string | null
}

export interface CommentsResponse {
	comments: Comment[]
	count: number
}

export enum Status {
	Published = "Published",
	Unpublished = "Unpublished"
}

export interface ResourceRespose{
  acceptsComments: boolean
  author: User
  description: string
  downloadLink: string
  createdAt: string
  createdBy: User
  id: string
  participants: User[]
  researchFields: string[]
  status: Status
	title: string
	_type: 'Audio' | 'Text' | 'Video'
}

export interface User {
	firstName: string
	imageUrl: string
	isDeleted: boolean
	lastName: string
	role: Role
	userId: string
}

export interface FormField {
	id: "researchFields" | "description" | "title" | "acceptsComments" | "author"
	label?: string
	type: "date" | "select" | "selectMultiple" | "tags" | "text" | "textArea" | "year"
	rules?: { [key: string]: boolean }
	options?: { alternateTranslationPrefix?: string, type?: "codeBased", optionList: Option[] }
	placeholder?: string
	layout: "w25" | "w50" | "w100"
}

export interface UsersResponse {
	bookmarkId?: string
	education: []
	firstName: string
	imageId: string
	isDeleted: boolean
	lastName: string
	location?: string
	researchAreas?: string[]
	role: Role
	userId: string
	workExperience: string[]
}

export interface UsersResponseWithPagination {
	count: number
	users: {
		firstName: string
		imageId: string
		lastName: string
		location?: string
		role: Role
		userId: string
	}[]
}

export type Participant = User;


export interface Option {
	label: string
	value: any
}

export interface FormModel {
	acceptsComments: boolean
	author: string
	description: string
	researchFields: string[]
	title: string
}

export enum Role {
	Admin = "Admin",
	ApplicantMentee = "ApplicantMentee",
	Mentee = "Mentee",
	Mentor = "Mentor",
}

export enum ResourceType{
	Audio = "Audio",
	Text = "Text",
	Video = "Video"
}